import styled from 'styled-components';
import { palette, tokens } from '../../styles';

export const Button = styled.button`
  ${tokens.font['xs-emphasys']};
  color: ${palette['color-brand-primary']};

  background: transparent;
  border: 0;
  outline: 0;

  cursor: pointer;
`;